import React from "react";

const NormalGradientButton = ({ onClick, count = false, icon = false, text }) => {
  return (
    <>
      <div className="colorborder btn">
        <button className="normalbtn" onClick={onClick}>
          {icon && icon} {text && text} {count && <span className="count">{count}</span>}
        </button>
      </div>
    </>
  );
};

export default NormalGradientButton;
